import { useEffect } from 'react';

import { INVOICE_SCHEMA, type InvoiceType } from '@goshippo/libraries/shared/InvoicesTable';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { newRelic } from '~/utils/newRelic/newRelic';
import { safeParseWithLogging } from '~/utils/zodHelpers';

import { INVOICE_DETAILS_CACHE_KEY } from '../constants/invoicePage.const';
import * as invoicesService from '../services/invoices.service';

export const useFetchInvoiceDetails = (
  invoiceId: string,
): UseQueryResult<InvoiceType, AxiosError> => {
  const query = useQuery<InvoiceType, AxiosError>({
    queryFn: async () => {
      const response = await invoicesService.getById(invoiceId);
      return safeParseWithLogging(response, INVOICE_SCHEMA.describe('INVOICE_SCHEMA'));
    },
    queryKey: [invoiceId, INVOICE_DETAILS_CACHE_KEY],
  });

  useEffect(() => {
    if (query.error)
      newRelic.noticeError('Error while fetching invoice details', { error: query.error });
  }, [query.error]);

  return query;
};
